import { UserLocationContext } from '@honda-canada/user-location';
import { useContext } from 'react';
import useSettings from './useSettings';
var useUserOrDefaultProvince = function () {
    var userLocation = useContext(UserLocationContext);
    var defaultProvince = useSettings().defaultProvince;
    return (userLocation === null || userLocation === void 0 ? void 0 : userLocation.provinceCode) || defaultProvince;
};
export default useUserOrDefaultProvince;
